import { getPathname } from './get-pathname';
export const isExternalRoute = (route, routes)=>{
    const pathname = getPathname(route);
    if (routes.externalRoutes?.absolute.includes(pathname) || routes.externalRoutes?.catchAll.some((url)=>pathname.startsWith(url))) {
        return true;
    }
    if (routes.internalRoutes?.absolute.length || routes.internalRoutes?.catchAll.length) {
        return !routes.internalRoutes.absolute.includes(pathname) && !routes.internalRoutes.catchAll.some((url)=>pathname.startsWith(url));
    }
    return false;
};

//# sourceMappingURL=is-external-route.js.map